'use client'
import { TabPanels as ChakraTabPanels } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { TabPanelsProps } from './TabPanels.types'

export default forwardRef(function TabPanels(
  props: TabPanelsProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraTabPanels {...props} ref={ref} translate="no" />
})
